import React from 'react'

const SpinnerIcon: React.FC = () => {
  return (
    <svg className="QuickStart__spinner-svg" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="16" stroke="var(--qs-spinner-track)" strokeWidth="3" />
      <path d="M36 20C36 11.163 28.837 4 20 4" stroke="var(--qs-accent)" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

export default SpinnerIcon
